import { Button, Upload } from "antd"
import {LoadingOutlined, MinusCircleFilled, PlusOutlined} from "@ant-design/icons"
import { observer } from "mobx-react"
import { toastMsg } from "../../utilities/helpers/ToastHelper";
interface ImageUploaderProps{
    loadingStatus?: boolean,
    size?: number,
    src: any,
    onFileChange:  (event: any) => void,
    removeAction:  (event: any) => void,
    className?: string
}
const ImageUploader = ({loadingStatus = false, size=80, onFileChange, src, removeAction, className}: ImageUploaderProps)=>{
    const handleChange = (info: any) => {
        // Lấy file từ thông tin
        const file = info.file.originFileObj;
        if (file) {
            onFileChange(file); // Gọi hàm xử lý khi có file
        }
    };
    const handleBeforeUpload = (event:any)=>{
        const isImg = event.type === 'image/jpeg' || event.type === 'image/png';
        if(!isImg){
            toastMsg.error('Vui lòng chọn file ảnh', '')
            return Upload.LIST_IGNORE;
        }
        else{
            return true;
        }
    }
    const handleRemove = (event: React.MouseEvent) => {
        event.stopPropagation();
        removeAction(event);
    };
    return(
        <>
            <Upload className={className} style={{width: `${size}px`, height: `${size}px`}} onChange={handleChange} beforeUpload={handleBeforeUpload} showUploadList={false}>
                {src ? (<div className="w-fit h-fit relative"><img className="object-cover object-center rounded-md" src={src} style={{width: `${size}px`, height: `${size}px`}}/>
                <Button style={{padding: '0'}} className="bg-transparent absolute -top-2 -right-2" shape="circle" variant="dashed" type="link" danger icon={<MinusCircleFilled/>} onClick={(event)=>{handleRemove(event)}}/></div>):
                (<Button danger className="flex flex-col gap-2" style={{width:`${size}px`, height:`${size}px`}}>
                    {loadingStatus ? <LoadingOutlined/> : <PlusOutlined/>}
                    <div>Tải lên ảnh</div>
                </Button>)}
            </Upload>
        </>
    )
}
export default observer(ImageUploader)